import SkeletonLoader from './index';

const ClassDetailsSkeleton = () => {
  return (
    <div className="p-6 space-y-6">
      {/* Header & Search */}
      <div className="flex items-center justify-between gap-4">
        <SkeletonLoader width={350} height={48} className="rounded-xl" />
        <div className="flex gap-4">
          <SkeletonLoader width={120} height={40} />
          <SkeletonLoader width={140} height={40} />
        </div>
      </div>

      {/* Teachers Section */}
      <div className="space-y-4">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2">
            <SkeletonLoader width={150} height={28} />
            <SkeletonLoader width={40} height={20} className="rounded-full" />
          </div>
          <SkeletonLoader width={100} height={36} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="border border-neutral-200 rounded-2xl p-4 space-y-4"
            >
              <div className="flex items-center gap-4">
                <SkeletonLoader variant="circle" width={48} height={48} />
                <SkeletonLoader width={120} height={24} />
              </div>
              <div className="space-y-2">
                <div className="flex gap-2">
                  <SkeletonLoader width={20} height={20} />
                  <div className="space-y-1">
                    <SkeletonLoader width={100} height={16} />
                    <SkeletonLoader width={150} height={20} />
                  </div>
                </div>
                <div className="flex gap-2">
                  <SkeletonLoader width={20} height={20} />
                  <div className="space-y-1">
                    <SkeletonLoader width={100} height={16} />
                    <SkeletonLoader width={150} height={20} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lesson Breakdown Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <SkeletonLoader width={150} height={28} />
          <SkeletonLoader width={40} height={20} className="rounded-full" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="border border-neutral-200 rounded-2xl p-4 h-[88px] flex items-center justify-between"
            >
              <div className="space-y-1">
                <SkeletonLoader width={120} height={20} />
                <SkeletonLoader width={80} height={16} />
              </div>
              <SkeletonLoader width={80} height={24} className="rounded-full" />
            </div>
          ))}
        </div>
      </div>

      {/* Student Progress Table */}
      <div className="space-y-4">
        <SkeletonLoader width={200} height={28} />
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <SkeletonLoader width={150} height={28} />
          <SkeletonLoader width={100} height={32} />
        </div>
      </div>
    </div>
  );
};

export default ClassDetailsSkeleton;
